import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useEffect } from 'react';
import { TopSellingProducts } from '../../Domain/Model/Metric';
import { CarouselDash } from '../Components/CarouselDash';
import ChartBasic from '../Components/ChartBasic';
import ChartDoughnut from '../Components/ChartDoughnut';
import './home.css';
import HomeViewModel from './HomeViewModel';



export const Home = ()=> {
    
    const {
        getMetrics,
        metrics,
        getLowStockProducts,
        lowStockProducts,
        getMonthlySales,
        monthlySales
      } = HomeViewModel();

    const handleYearChange = (year: number) => {
        getMonthlySales(year);
    };
            

     useEffect(() => {
        getMetrics();
        getLowStockProducts();
        getMonthlySales(new Date().getFullYear());
    }, []);

    return (
        <>
             <div className="container-fluid">
                    <div className="block-header">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                                <h2>Dashboard</h2>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="#" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                                    </li>                            
                                    <li className="breadcrumb-item">Dashboard</li>
                                </ul>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="d-flex flex-row-reverse">
                                    <div className="page_action">
                                    </div>
                                    <div className="p-2 d-flex">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className='content-cards row pb-3'>
                        <article className="col-lg-3">
                            <section className='card card-dash m-1'>
                                <section>
                                    <article className='article1'>
                                        <FontAwesomeIcon icon={icon({name: 'shirt'})} className='icon' />
                                        <section className='article2'>
                                            <p className='text'>Ventas diarias</p>
                                            <div className='number'>{metrics?.totalSalesCount ?? 0}</div>
                                        </section>
                                    </article>
                                    <article className='article3'>
                                        <FontAwesomeIcon icon={icon({name: 'caret-up'})} />&nbsp;19,8 %
                                    </article>
                                </section>
                            </section>
                        </article>
                        <article className="col-lg-3">
                            <section className='card card-dash m-1'>
                                    <section>
                                    <article className='article1'>
                                        <FontAwesomeIcon icon={icon({name: 'file'})} className='icon' />
                                            <section className='article2'>
                                            <p className='text'>Órdenes activas</p>
                                            <div className='number'>{metrics?.activeOrders.totalCount ?? 0}</div>
                                        </section>
                                    </article>
                                    <article className='article3'>
                                        <FontAwesomeIcon icon={icon({name: 'caret-up'})} />&nbsp;2,1 %
                                    </article>
                                </section>
                            </section>
                        </article>
                        <article className="col-lg-3">
                            <section className='card card-dash m-1'>
                                    <section className='d-flex flex-column'>
                                    <p>Productos más vendidos</p>
                                    <CarouselDash data={metrics?.topSellingProducts ?? []} />
                                </section>
                            </section>
                        </article>
                        <article className="col-lg-3">
                            <section className='card card-dash m-1'>
                                    <section>
                                    <article className='article1'>
                                        <FontAwesomeIcon icon={icon({name: 'user'})} className='icon' />
                                            <section className='article2'>
                                            <p className='text'>Usuarios activos</p>
                                            <div className='number'>{metrics?.activeUsersCount ?? 0}</div>
                                        </section>
                                    </article>
                                    
                                    <article className='article3'>
                                        <FontAwesomeIcon icon={icon({name: 'caret-up'})} />&nbsp;5,2 %
                                    </article>
                                </section>
                            </section>
                        </article>
                    </section>
                    <section className='row pb-4'>
                        <div className='col-lg-6'>
                            {monthlySales ? <ChartBasic dataMonthlySales={monthlySales ?? []} onYearChange={handleYearChange} /> : <div>Cargando...</div>}
                        </div>
                         <div className='col-lg-6'>
                            {metrics ? 
                            
                            <ChartDoughnut details={metrics?.activeOrders.details ?? []} />
                            : <div>Cargando...</div>}
                        </div>
                    </section>
                    <section className='row pb-4'>
                       <div className='col-lg-6'>
                            <section className='card card-chart'>
                                <p className='title-char'>Productos más vendidos</p>
                                <section className="scrollProduct">
                                     <section className='table-report'>
                                        <table className="table table-stripped table-hover">
                                            <tbody>
                                                {
                                                    metrics?.topSellingProducts.map((product: TopSellingProducts, i: number)=>{

                                                        return(
                                                             <tr>
                                                                <td>
                                                                    <img key={i} className='img-fluid' src={`${product?.productImageUrl}`} alt={product.productName} />
                                                                </td>
                                                                <td>{product.productName}</td>
                                                                <td className="text-right"><strong className='green-alert-stock'>{product.stock}</strong></td>
                                                            </tr>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                     </section>
                                </section>
                            </section>
                        </div>
                         <div className='col-lg-6'>
                             <section className='card card-chart'>
                                <p className='title-char'>Productos con el stock por caerse</p>
                                <section className="scrollProduct">
                                     <section className='table-report'>
                                        <table className="table table-stripped table-hover">
                                            <tbody>
                                                { lowStockProducts ?
                                                   
                                                    lowStockProducts?.map((product: TopSellingProducts, i: number) => {

                                                        return(
                                                             <tr>
                                                                <td>
                                                                    <img key={i} className='img-fluid' src={`${product?.productImageUrl}`} alt={product?.productName} />
                                                                </td>
                                                                <td>{product?.productName}</td>
                                                                <td className="text-right">
                                                                    {product.stock &&
                                                                        <strong className={`${product?.stock <=2 ? 'red-alert-stock' : 'yelow-alert-stock'}`}>{product.stock}</strong>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                   
                                                    :
                                                    <tr>
                                                        <td colSpan={3}>Cargando...</td>
                                                    </tr>
                                                }
 
                                            </tbody>
                                        </table>
                                     </section>
                                </section>
                            </section>
                        </div>
                    </section>

                </div>
        </>
    );
}